import { Link } from 'gatsby'
import { lighten, shade, readableColor } from 'polished'
import styled, { css } from 'styled-components'
import breakpoint from 'styled-components-breakpoint'

export const styles = css`
  border: 3px solid transparent;
  display: inline-block;
  text-decoration: none;
  border-radius: 2rem;
  font-size: 1rem;
  font-weight: bold;
  padding: 0.75rem 2.5rem;
  margin: 0;
  cursor: pointer;
  transition: 0.3s;

  box-shadow: 0px 2px #1F1F1F;

  ${props => props.fullwidthMobile && css`
    width: 100%;

    ${breakpoint('tablet')`
      width: unset;
    `}
  `}

  ${props => props.small && css`
    font-size: 0.75rem;
    padding: 0.5rem 1.5rem;
    border-width: 2px;
  `}

  ${props => props.large && css`
    font-size: 1.25rem;
    padding: 1rem 3.5rem;
    border-width: 3px;
  `}

  ${props => props.primary && css`
    color: white;
    background-color: #9F292C;
    border-color: #9F292C;

    &:hover {
      background-color: ${lighten(0.05, '#9F292C')};
      border-color: ${lighten(0.05, '#9F292C')};
    }

    ${props.outlined && css`
      color: #9F292C;
      background-color: transparent;
      border-color: #9F292C;

      &:hover {
        background-color: #9F292C;
        color: white;
      }
    `}
  `}

  ${props => props.secondary && css`
    color: white;
    background-color: ${shade(0.5, '#9F292C')};
    border-color: ${shade(0.5, '#9F292C')};

    &:hover {
      background-color: #9F292C;
      border-color: #9F292C;
    }

    ${props.outlined && css`
      color: ${shade(0.5, '#9F292C')};
      background-color: transparent;
      border-color: ${shade(0.5, '#9F292C')};

      &:hover {
        background-color: ${shade(0.5, '#9F292C')};
        color: white;
      }
    `}
  `}

  ${props => props.white && css`
    color: #1F1F1F;
    background-color: white;
    border-color: #1F1F1F;

    ${props.outlined && css`
      color: white;
      background-color: transparent;
      border-color: white;

      &:hover {
        background-color: white;
        color: #1F1F1F;

        ${props.pinkHover && css`
          background-color: #DE1C85;
          color: white;
          border-color: #DE1C85;
        `}
      }
    `}
  `}

  ${props => props.success && css`
    color: #1F1F1F;
    background-color: #2C9F29;
    border-color: #2C9F29;

    &:hover {
      background-color: ${lighten(0.05, '#2C9F29')};
      border-color: ${lighten(0.05, '#2C9F29')};
    }

    ${props.outlined && css`
      color: #2C9F29;
      background-color: transparent;
      border-color: #2C9F29;

      &:hover {
        background-color: #2C9F29;
        color: ${readableColor('#2C9F29', '#FFFFFF', '#1F1F1F')};
      }
    `}
  `}
`

export const StyledLink = styled(Link)`
  ${styles}
`

export const StyledA = styled.a`
  ${styles}
`

export const StyledButton = styled.button`
  ${styles}
`
